import { addEventMergeIdIfVariationChangedAndExists } from '../../../_common/client/tracking';
import { ImagesSubComponent } from '../images.sub.component';

interface ComboPromoVariationChangedEventPayload {
    articleNumber: string;
    targetElement: HTMLElement;
    imageId: string;
    imagePreset: string;
    eventMergeId?: string;
    variationId: string;
}

interface ComboPromoImageChangedEventPayload {
    imageId: string;
}

export class ComboPromoButtonSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_combo-promo-button';
    private imageIds: string[] = [];

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.getImageIds();

        const comboPromoVariationChangedEventPayload: ComboPromoVariationChangedEventPayload = {
            articleNumber: this.getRootElement().dataset.articleNumber || '',
            targetElement: this.getRootElement(),
            imageId: this.imageIds[0],
            imagePreset: '$001PICT36$',
            variationId: this.getRootElement().dataset.variationId || '',
        };
        o_global.eventQBus.emit(
            'ft3.combopromo.variationChanged',
            addEventMergeIdIfVariationChangedAndExists(comboPromoVariationChangedEventPayload)
        );
    }

    private getImageIds() {
        const slideElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js_pdp_main-image__slide');
        if (slideElements) {
            Array.from(slideElements).forEach((slide: HTMLElement) => {
                this.imageIds.push(slide.dataset.imageId as string);
            });
        }
    }

    protected onImageChanged(index: number) {
        const comboPromoImageChangedPayload: ComboPromoImageChangedEventPayload = {
            imageId: this.imageIds[index],
        };
        o_global.eventQBus.emit('ft3.combopromo.imageChanged', comboPromoImageChangedPayload);
    }
}
